"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "hash/5.0.1";
